import axios from 'axios';

const BASE_URL = "https://craft.filmallmende.net";

export default async (url, method, options = {}) => axios ({
    method: method.toUpperCase(),
    url: BASE_URL + url,
    ...options,
});
